import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

class OurStory extends React.Component {

    render() {
        return (
            <>
                <LandingHeader />
                
                <div className="breadcrumb-area shadow dark bg-fixed text-center text-light" style={{"backgroundImage": "url(assets/edocom/img/banner/4.jpg)"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <h1>Our Story</h1>
                                <ul className="breadcrumb">
                                    <li><a href="#/"><i className="fas fa-home"></i> Home</a></li>
                                    <li><a href="#/">About Us</a></li>
                                    <li className="active">Our Story</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="about-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="about-items">
                                <div className="col-md-12 about-info">
                                    <h2>Welcome ! <span>This site is developed and maintained by Shouvik!</span></h2>
                                    <blockquote>
                                        This website is developed and maintained by Shouvik Sarkar. He is a web developer and developed apps in multiple technologies and programming languages. The development of this website started in Nov 2024 and it's completion of first phase is in Feb 2025. After the first phase development it provides very basic features including URL shortening and link tracking based on location. As we go we are always looking to add more and more features into it. We developed and operate couple of two user based platforms before it being Biznet and Enroute and this is third in the list besides some desktop applications as well adding to the list. We are always developing and look to provide more applications and technologies for our users. We are glad you have read our story and interested in our services!
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default OurStory;
